module.exports = __webpack_public_path__ + "img/1.6.ba05504f.png";